export default __webpack_public_path__ + "static/media/frangot-screenshot-01.ac9d0342.png";